import { Directive } from '@angular/core';

@Directive({
  selector: 'cp-error',
  host: {
    class: 'error-message error-message--entry-field',
    role: 'alert',
  },
})
export class CpError {}
